module.exports = __webpack_public_path__ + "img/pencil.c5c0cfdc.svg";